import React from 'react';

const Recommended = (props) => {

  const dataParent = props.data;
  const casuistic = props.casuistic;
  const growthDisclaimer = props.data.growthDisclaimer;
  const isGrowthMode = casuistic === "growth";
  const mealsPerDayLabel = props.data.mealsPerDayLabel;
  const mealsPerDay = props.mealsPerDay;
  const currentBodyWeight = dataParent.data.calculatedCurrentWeight;
  const kcalLabel = props.data.kcalLabel;
  let heading = dataParent.heading;
  let data = dataParent.data;
  let products = dataParent.products;

  // The number of columns
  const cols = data.dates.length;

  // Function that returns the first word in the sentence with bold
  const makeFirstWordBold = (sentence) => {
    const splittedString = sentence.split(" ");

    splittedString[0] = `<span style="font-weight: bold">${splittedString[0]}</span>`;

    return splittedString.join(" ");
  };

  // Create the DER header
  const derHeader = `
    <td colspan="${cols}" class="nppe2-fc-feeding-guidelines-recommended__table-section-header">
      ${data.der[0].label}
    </td>
  `;

  let derData = [];

  (data.der.map((item, groupIndex) => {
    let itemData = parseFloat(item.data);
    derData.push(`${itemData.toFixed(0)} ${kcalLabel}`)
  }));

  // Create the label + product
  let productSections = [];

  Object.keys(products).forEach(function(key) {
    (products[key].map((product, productIndex) => {

      if (key == "related"){
        key = "supplement";
      }

      let sectionTitle;
      let output = {
        perDay: [],
        perMeal: [],
      };

      if (key == "dry" || key == "wet"){
        sectionTitle = (key === "dry") ? data.labels[0]['dryLabel'] : data.labels[0]['wetLabel'];

        product.grams_per_day.forEach(g => {
          output.perDay.push(g);
        });

        product.grams_per_meal.forEach(g => {
          output.perMeal.push(g);
        });

        productSections.push({
          label: `${sectionTitle}: ${product.title}`,
          data: {
            "perDay": output.perDay,
            "perMeal": output.perMeal,
          }
        });
      }

      if (key == "snack" || key == "supplement" || key == "related"){
        const isHydracare = product.title.toLowerCase().includes("hydra");
        sectionTitle = data.labels[0]['othersLabel']

        productSections.push({
          label: `${sectionTitle}: ${product.title}`,
          data: isHydracare ?
              {
                "perDay": data.der.map(
                  (der) => ((Math.round(((parseInt(der.data) * 0.1) / product.energy_per_package)*2)/2) + product.units_per_day).replace('.0', '')
                ),
                "perMeal": data.der.map(() => "")
              }
            :
              { "perDay": product.units_per_day }
        });
      }

    }))
  });

  return (
    <div className="nppe2-fc-feeding-guidelines-recommended" id="fc-screenshot-feeding-guidelines-recommended">
      <div className="row">

        <div className="col-xs-12 nppe2-fc-sub-title-output">
          {heading}
        </div>

        <div className="col-xs-12">
          <table className="table nppe2-fc-feeding-guidelines-recommended__table">
            <tbody>
              <tr className="nppe2-fc-feeding-guidelines-recommended__table-section-secondary-header">
                {Array.from(data.dates, (date, key) => {
                  if (isGrowthMode) {
                    if (key === 0) {
                      return (
                        <td>
                          {date}
                        </td>
                      );
                    };

                    if (key === 1) {
                      return (
                        <td width="20%">
                          {mealsPerDayLabel}: {mealsPerDay}
                        </td>
                      );
                    };

                  } else {
                    return (
                      <td>
                        {date}
                      </td>
                    );
                  };
                })}
              </tr>

              <tr dangerouslySetInnerHTML={{__html: derHeader}}></tr>

              <tr>
                {
                  derData.reduce((result, item, index) => {
                    if (!isGrowthMode || index === 0) {
                      result.push(
                        <td>
                          {item}
                        </td>
                      );
                    }
                    return result;
                  }, [])
                }
              </tr>

              {productSections.map((item, index) => {
                return (
                  <>
                    <tr>
                      <td colSpan={cols} className="nppe2-fc-feeding-guidelines-recommended__table-section-header">
                        {item.label}
                      </td>
                    </tr>

                    {Array.isArray(item.data.perDay) ?
                      <tr>
                        {item.data.perDay[0] !== undefined &&
                          <td width="20%">
                            <div>{item.data.perDay[0]}</div>
                            <div>{item.data.perMeal[0]}</div>
                          </td>
                        }
                        {
                          isGrowthMode ? null :
                            <>
                              {item.data.perDay[1] !== undefined &&
                                <td width="20%">
                                  <div>{item.data.perDay[1]}</div>
                                  <div>{item.data.perMeal[1]}</div>
                                </td>
                              }

                              {item.data.perDay[2] !== undefined &&
                                <td width="20%">
                                  <div>{item.data.perDay[2]}</div>
                                  <div>{item.data.perMeal[2]}</div>
                                </td>
                              }

                              {item.data.perDay[3] !== undefined &&
                                <td width="20%">
                                  <div>{item.data.perDay[3]}</div>
                                  <div>{item.data.perMeal[3]}</div>
                                </td>
                              }

                              {item.data.perDay[4] !== undefined &&
                                <td width="20%">
                                  <div>{item.data.perDay[4]}</div>
                                  <div>{item.data.perMeal[4]}</div>
                                </td>
                              }
                            </>
                        }
                      </tr>
                    :
                      <tr>
                        <td width="20%">
                          <div>{item.data.perDay}</div>
                          <div>{item.data.perMeal}</div>
                        </td>
                        {isGrowthMode ? null :
                          <>
                            <td width="20%">
                              <div>{item.data.perDay}</div>
                              <div>{item.data.perMeal}</div>
                            </td>

                            <td width="20%">
                              <div>{item.data.perDay}</div>
                              <div>{item.data.perMeal}</div>
                            </td>

                            <td width="20%">
                              <div>{item.data.perDay}</div>
                              <div>{item.data.perMeal}</div>
                            </td>

                            <td width="20%">
                              <div>{item.data.perDay}</div>
                              <div>{item.data.perMeal}</div>
                            </td>
                          </>
                        }
                      </tr>
                    }
                  </>
                );
              })}

            </tbody>
          </table>
          {
            isGrowthMode &&
            <div className="nppe2-fc-feeding-guidelines-recommended__growth-disclaimer">
              <p dangerouslySetInnerHTML={{__html: makeFirstWordBold(growthDisclaimer)}}></p>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

export default Recommended;
